import {
  types,
  resolveIdentifier,
  isStateTreeNode,
  getIdentifier,
  IAnyModelType,
  IReferenceType,
  ReferenceIdentifier,
  ISimpleType,
} from 'mobx-state-tree';

export function safeReference<T extends IAnyModelType>(
  subType: T,
): IReferenceType<T> {
  return types.reference(subType, {
    get(identifier, parent) {
      if (isStateTreeNode<T>(identifier)) {
        identifier = getIdentifier(identifier) as ReferenceIdentifier;
      }

      // TODO: add correct types
      return resolveIdentifier<any>(subType, parent, identifier);
    },

    set(value) {
      return value;
    },
  });
}

export type UnionNumberArrayType<T extends number[]> = T[number];

export function enumerationNumber<T extends number>(
  options: T[],
): ISimpleType<UnionNumberArrayType<T[]>>;
export function enumerationNumber<T extends number>(
  name: string,
  options: T[],
): ISimpleType<UnionNumberArrayType<T[]>>;
export function enumerationNumber<T extends number>(
  name: string | T[],
  options?: T[],
): ISimpleType<T> {
  const realOptions: number[] =
    typeof name === 'string' ? options! : name;

  const type = types.union(
    ...realOptions.map((option) => types.literal(option)),
  );

  if (typeof name === 'string') {
    type.name = name;
  }

  return type;
}
